import React from 'react';
import { Spinner } from 'react-bootstrap';
import i18n from '../../i18n';

const Loader = (props) => {
  return (
    <div
      className="d-flex align-items-center justify-content-center custom-loader"
      {...props}>
      <Spinner animation="border" role="status">
        <span className="visually-hidden">{i18n.t('event.loading')}</span>
      </Spinner>
    </div>
  );
};

export default Loader;
